import {
  ExecutiveListActionTypes,
  GetPatientDemographicsState,
  GET_EXECUTIVE_SUCCESS,
  GET_EXECUTIVE_LOADING,
  GET_EXECUTIVE_FAIL,
} from "./ActionTypes";
import { ExecutiveListResponse } from "./Model";

const initialStateGetPosts: GetPatientDemographicsState = {
  loading: false,
  executiveListDropDownRes: {} as ExecutiveListResponse,
};
export const executiveListReducer = (
  state = initialStateGetPosts,
  action: ExecutiveListActionTypes
): GetPatientDemographicsState => {
  switch (action.type) {
    case GET_EXECUTIVE_SUCCESS:
      return {
        ...state,
        loading: false,
        executiveListDropDownRes: action.payload,
      };
    case GET_EXECUTIVE_LOADING:
      return {
        ...state,
        loading: true,
        executiveListDropDownRes: {} as ExecutiveListResponse,
      };
    case GET_EXECUTIVE_FAIL:
      return {
        ...state,
        executiveListDropDownRes: {} as ExecutiveListResponse,
        loading: false,
      };
    default:
      return state;
  }
};
